import React from 'react';
import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom';

import Home from './Home';
import Product from './modules/basic/product/Product';
import Ship from './modules/basic/ship/Ship';
import Vehicle from './modules/basic/vehicle/Vehicle';
import Driver from './modules/operation/driver/Driver';
import Customer from './modules/operation/customer/Customer';
import LogisticRoute from './modules/operation/logisticRoute/LogistiRoute';
import ShippingCompany from './modules/operation/shippingCompany/ShippingCompany';
import User from './modules/account/user/User';
import UserAccess from './modules/account/access/UserAccess';
import CreateChangePassword from './modules/account/CreateChangePassword';
import Login from './modules/account/Login';
import CreateTransportLogiscticRoute from './modules/transportLogisticRoute/CreateTransportLogiscticRoute';
import CancelTransportLogiscticRoute from './modules/transportLogisticRoute/CancelTransportLogisticRoute';
import PageNotFound from './pages/PageNotFound';
import Unauthorized from './pages/Unauthorized';

function Routes() {
	return (
		<BrowserRouter>
			<Switch>
				<Route exact path="/" component={Login} />
				<Route exact path="/login" component={Login} />
				<Route exact path="/home" component={Home} />
				<Route path="/nao-authorizado" component={Unauthorized} />
				<Route path="/pagina-nao-encontrada" component={PageNotFound} />
				<Route path="/cadastro/produtos" component={Product} />
				<Route path="/cadastro/navios" component={Ship} />
				<Route path="/cadastro/veiculos" component={Vehicle} />
				<Route path="/operacao/motoristas" component={Driver} />
				<Route path="/operacao/clientes" component={Customer} />
				<Route path="/operacao/rotas-carregamento" component={LogisticRoute} />
				<Route path="/operacao/transportadoras" component={ShippingCompany} />
				<Route path="/criar-senha/:token" component={CreateChangePassword} />
				<Route path="/alterar-senha/:token" component={CreateChangePassword} />
				<Route path="/lancamento/nota-carregamento" component={CreateTransportLogiscticRoute} />
				<Route path="/lancamento/cancelar-nota-carregamento" component={CancelTransportLogiscticRoute} />
				<Route path="/seguranca/usuarios" component={User} />
				<Route path="/seguranca/acesso-usuarios" component={UserAccess} />
				<Redirect from="*" to="/pagina-nao-encontrada" />
			</Switch>
		</BrowserRouter>
	);
}

export default Routes;
